import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import FuelTankList from './FuelTankList';
import { icon } from 'leaflet';

//redux

const FuelTank = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Estanque de Combustible' links={breadcrumbLinks} icon={'icon-database'} />
					<FuelTankList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FuelTank;
